import React, { useState } from "react";
import "../css/itemavilibility.css";
import PaymentPopup from "./PaymentPopup";
import TableRowCollapse from "./TableRowCollapse"

let paymentProps = {};
export default function OrderSummaryTable({
  value,
  searchHandler,
  tableContainerStyle,
  setIsOrdersTablePopUpOpen,
  ...props
}) {

  const [runningOrder, setRunningOrder] = useState(value);
  const [isPaymentOptionOpen, setPaymentOptionOpen] = useState({ status: false, amount: 0, callback: null });

  return (
    <>
      <div className="itemavilablelity" style={tableContainerStyle || { left: "-100px" }}>
        <div className="orderDetailsContainer" >
          <div className='tabular-content' style={{ overflowY: 'auto', marginTop: '0px', height: 'fit-content', maxHeight: '88vh', }}>
            <table className="f6 w-100 center" cellSpacing="0">
              <tbody>
                <TableRowCollapse
                  visible={true}
                  value={value}
                  setIsOrdersTablePopUpOpen={setIsOrdersTablePopUpOpen}
                  searchHandler={searchHandler}
                  runningOrder={runningOrder}
                  setRunningOrder={setRunningOrder}
                  isPaymentOptionOpen={isPaymentOptionOpen}
                  setPaymentOptionOpen={setPaymentOptionOpen}
                  paymentProps={paymentProps}
                  {...props}
                />
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {isPaymentOptionOpen.status && (
        <PaymentPopup
          isPaymentOptionOpen={isPaymentOptionOpen}
          setPaymentOptionOpen={setPaymentOptionOpen}
          customerInfo={{ name: runningOrder?.customer_name, number: runningOrder?.customer_mobile }}
          setCustomerInfo={info => setRunningOrder(curr => ({ ...curr, customer_name: info.name, customer_mobile: info.number1 }))}
          containerStyle={{ width: '100%', left: '15px', zIndex: '100' }}
          {...paymentProps}
        />
      )}
    </>
  );
}